import { useMemo } from 'react';

import { useIsAskMeAnythingEnabled, useIsOnlineMeetingEnabled, useIsQuestionsOnlyMode } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventEditingPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventEditingPage'> = (
  options
) => {
  const askMeAnythingEventEditingPageOverrides = options?.overrides?.askMeAnythingEventEditingPage;

  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isOnlineMeetingToggleEnabled = useIsOnlineMeetingEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        onlineMeetingToggleEnabled: isOnlineMeetingToggleEnabled,
        ...askMeAnythingEventEditingPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMAEnabled,
      onlineMeetingToggleEnabled: isOnlineMeetingToggleEnabled,
      ...askMeAnythingEventEditingPageOverrides,
    };
  }, [askMeAnythingEventEditingPageOverrides, isAMAEnabled, isQuestionsOnlyMode, isOnlineMeetingToggleEnabled]);
};
